export interface ChargeTypeMap {
    [key:string]: string,
}

export interface ChargeSummaryMap {
    [key:string]: ChargeTypeMap
}

export const EMPTY_CHARGE_SUMMARY_MAP = {}